module.exports = __webpack_public_path__ + "static/media/sort-down.60dd01dd.svg";